<template>  
   <router-view />
</template>
